<template>
  <div class="informationDisclosure">
    <z-fix-top ref="fixtop" keep-position class="fixtop" :style="{ background: '#F7F7F7' }">
      <z-nav-bar class="navbar" left-arrow :title="navTitle" @click-left="handleClickLeft">
      </z-nav-bar>
    </z-fix-top>
    <div class="content">
      <div v-if="stage == 1">
        <div class="title">
          1/<div style="color: grey;display: inline;">2</div> 第一步，请填写邮箱并验证
        </div>
        <div class="desc">
          此邮箱作为接收交易另一方资料的查收邮箱。为了确保邮箱有效，填写邮箱后，点击发送验证码，将您邮箱收到的验证码输入后提交验证邮箱。
        </div>
        <div class="input">
          <z-cell-group inset>
            <z-field v-model="email" center clearable placeholder="请输入您的收件邮箱">
            </z-field>
            <z-field v-model="verificationCode" center clearable placeholder="请输入邮箱验证码">
              <z-button slot="button" size="small" type="text" @click="getEmailCode" class="emailButton" :disabled="getEmailDisabled || !!emailTime">
                <z-count-down v-if="emailTime" :time="emailTime" format="(ss 秒)" @finish="countDownFinish" />
                <div v-else>{{ emailButtonText }}</div>
              </z-button>
            </z-field>
          </z-cell-group>
        </div>
        <z-button type="primary" style="width: 100%; margin-top: 53px;" @click="submitEmail" :disabled="nextIsDisabled">下一步</z-button>
      </div>
      <div v-if="stage == 2">
        <div class="title">
          2/2 第二步，请选择披露信息
        </div>
        <div class="remind">
          请及时填写信息
        </div>
          <div class="question">1、请选择需要平台披露的内容（可多选）</div>
          <z-checkbox-group v-model="chooseType">
            <div class="option">
              <div class="typeLabel">对方注册手机号</div>
              <z-checkbox name="1" key="1" />
            </div>
            <div class="option">
              <div class="typeLabel"> 对方姓名、身份证号</div>
              <z-checkbox name="2" key="2"/>
            </div>
          </z-checkbox-group>
          <div class="question">2、请选择交易中遇到的问题（单选）</div>
          <z-radio-group v-model="chooseQuestion">
            <div class="option">
              <div class="questionLabel">收到的商品存在质量问题（手机数码等）</div>
              <z-radio name="收到的商品存在质量问题（手机数码等）" />
            </div>
            <div class="option">
              <div class="questionLabel">未收到货/收到空包裹</div>
              <z-radio name="未收到货/收到空包裹" />
            </div>
            <div class="option">
              <div class="questionLabel">已退回货物，卖家不退款</div>
              <z-radio name="已退回货物，卖家不退款" />
            </div>
            <div class="option">
              <div class="questionLabel">游戏账号被找回</div>
              <z-radio name="游戏账号被找回" />
            </div>
            <div class="option">
              <div class="questionLabel">其他问题</div>
              <z-radio name="其他问题" />
            </div>
            <z-field v-if="isShowTextArea" class="otherQuestion" v-model="textarea" type="textarea" :maxlength="100" placeholder="请简单描述您在交易中遇到的问题" />
            <div v-else class="interval"></div>
          </z-radio-group>
          <z-button-group keep-position>
            <z-checkbox-group v-model="agreement">
              <z-checkbox name="1" class="agreement">
                已阅读并同意
                <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《信息披露申请法律责任承诺函》</span>
              </z-checkbox>
            </z-checkbox-group>
            <z-button type="primary" @click="submitApply" @disabled-click="submitCheck" class="submitApply" :disabled="submitIsDisibled">
              提交申请
            </z-button>
          </z-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, FixTop, CellGroup, Field, CountDown, RadioGroup, Radio, Checkbox, CheckboxGroup, Toast, Button, ButtonGroup } from '@zz-common/zz-ui';
import { queryParams, getCookie } from '@lib/utils'
import { queryDisclosureStatus, submitDisclosureEmaile, queryDisclosureEmail, checkDisclosureEmail, submitDisclosure } from '@api/resourceApi'
import native from '@zz-common/native-adapter';

const query = queryParams()

export default {
  name: 'InformationDisclosureCommit',
  data() {
    return {
      navTitle: '信息披露申请',
      time: 48 * 60 * 60 * 1000,
      uid: getCookie('uid'),
      orderId: query.orderId || this.$route.query.orderId || '',
      chooseType: [],
      chooseQuestion: [],
      verificationCode: '',
      stage: 1,
      email: '',
      emailTime: 0,
      emailButtonText: '获取验证码',
      agreement: [],
      textarea: '',
      emailPattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    }
  },
  components: {
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    zButton: Button,
    'z-cell-group': CellGroup,
    'z-field': Field,
    'z-count-down': CountDown,
    'z-radio-group': RadioGroup,
    'z-radio': Radio,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup
  },
  computed: {
    isShowTextArea() {
      return this.chooseQuestion == '其他问题'
    },
    submitIsDisibled() {
      if (this.isShowTextArea && !this.textarea) {
        return true;
      }
      return !Boolean(this.chooseQuestion.length && this.chooseType.length && this.agreement.length)
    },
    getEmailDisabled() {
      return !this.emailPattern.test(this.email)
    },
    nextIsDisabled() {
      return !this.verificationCode || this.getEmailDisabled
    }
  },
  methods: {
    handleClickLeft() {
      native.close()
    },
    submitEmail() {
      const params = {
        uid: this.uid,
        email: this.email,
        orderId: this.orderId,
        verificationCode: this.verificationCode
      }
      checkDisclosureEmail(params).then(() => {
        this.stage = 2
      })
    },
    submitApply() {
      let type = 0;
      let question = this.chooseQuestion;
      if (this.chooseType.length == 1) {
        type = this.chooseType[0]
      }
      if (this.chooseType.length == 2) {
        type = 3
      }
      if (this.chooseQuestion == '其他问题') {
        question = this.textarea
      }
      const params = {
        uid: this.uid,
        orderId: this.orderId,
        chooseType: type,
        chooseQuestion: question
      }
      submitDisclosure(params).then(() => {
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/informationDisclosure/result?orderId=${this.orderId}&from=${this.from}&status=3`,
          needClose: '1'
        })
      })
    },
    countDownFinish() {
      this.emailButtonText = '重新获取'
      this.emailTime = 0
    },
    getEmailCode() {
      this.emailTime = 60 * 1000
      const params = {
        uid: this.uid,
        email: this.email,
        orderId: this.orderId
      }
      submitDisclosureEmaile(params)
    },
    submitCheck() {
      if (!this.chooseType.length) {
        Toast('请选择需要披露的内容')
      } else if (!this.chooseQuestion.length) {
        Toast('请选择遇到的问题')
      } else if (this.isShowTextArea && !this.textarea) {
        Toast('请输入其他问题')
      } else if (!this.agreement.length) {
        Toast('请勾选协议')
      }
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/661267d560acc50070f5a3d8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    }
  },
  created() {
    native.setTitle({
      title: '信息披露申请'
    })
    const params = {
      uid: this.uid,
      orderId: this.orderId
    }
    queryDisclosureStatus(params).then(res => {
      const { status, currentNode } = res;
      if (status > 0) {
        this.stage = 1;
      }
      if (status == 0) {
        if (currentNode == 0) {
          queryDisclosureEmail(params).then(res => {
            this.email = res.mail
          })
          this.stage = 1;
        } else if (currentNode == 1) {
          this.stage = 2;
        }
      }
    })
  }
}
</script>

<style scoped lang="less">
@import 'index.less';
</style>
